<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '@/composables/useI18n'
import { useAuth } from '@/composables/useAuth'
import { useEvents } from '@/composables/useEvents'

const { lang, t, setLanguage } = useI18n()
const { isAuthenticated, getLoginUrl } = useAuth()
const { lastUpdated } = useEvents()

const gitHash = import.meta.env.VITE_GIT_COMMIT || 'dev'

const formattedLastUpdated = computed(() => {
  if (!lastUpdated.value) return ''
  const date = new Date(lastUpdated.value)
  return date.toLocaleString(lang.value === 'de' ? 'de-CH' : 'en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
})

function openDataPrivacy() {
  document.dispatchEvent(new CustomEvent('open-data-privacy-modal'))
}
</script>

<template>
  <footer class="footer">
    <div class="footer-content">
      <p>
        <span id="lastUpdated">{{ t('last-updated') }} {{ formattedLastUpdated }}</span> |
        <span class="index-hash">{{ gitHash }}</span>
      </p>
      <p class="footer-legal">
        © {{ new Date().getFullYear() }}
        <a href="https://www.mironet.ch/" target="_blank" rel="noreferrer">MiroNet AG</a> |
        Gerbergasse 16, CH-4001 Basel |
        <a href="#" @click.prevent="openDataPrivacy">{{ t('data-privacy') }}</a> |
        <a v-if="!isAuthenticated" :href="getLoginUrl()">
          <span class="icon icon-login" aria-hidden="true"></span>
          <span class="sr-only">{{ t('admin-login') }}</span>
        </a>
      </p>
      <div class="footer-language">
        <div class="language-toggle">
          <button :class="['lang-btn', { active: lang === 'de' }]" @click="setLanguage('de')">DE</button>
          <button :class="['lang-btn', { active: lang === 'en' }]" @click="setLanguage('en')">EN</button>
        </div>
      </div>
    </div>
  </footer>
</template>
